import {
  RESET_ADDRESS_SUGGESTION,
  RESET_ADDRESS_SUGGESTION_NOT_ADDRESS,
} from 'redux/modules/address-suggestion/actions/types';

export const resetAddressSuggestion = () => ({
  type: RESET_ADDRESS_SUGGESTION,
});

export const resetAddressSuggestionNotAddress = () => ({
  type: RESET_ADDRESS_SUGGESTION_NOT_ADDRESS,
});
